import { LazyLottie } from '@/components/shared/lazy-lottie';
import animationOnProcess from '@assets/lottie-animation/onprocess.json';

export const PendingContent = () => {
  return (
    <div className="pb-6">
      <div className="grid min-h-full place-items-center rounded-xl border bg-white px-6 py-24 sm:py-10 lg:px-8">
        <div className="text-center">
          <h3 className="mt-4 text-3xl font-medium tracking-tight text-gray-900 sm:text-5xl">
            Upload Document Successful
          </h3>
          <p className="mx-auto mt-6 w-[500px] text-base leading-7 font-light text-gray-600">
            Thank you for signing up. Your account is currently under internal review by our
            verification team. We will notify you via email or your dashboard once the review is
            complete.
          </p>

          <LazyLottie
            className="mx-auto my-12 w-[180px]"
            animationData={animationOnProcess}
            loop={true}
          />

          <div className="space-y-3">
            <p className="text-sm text-gray-700">
              💬 If you have any questions, feel free to contact our customer service.
            </p>
          </div>

          <div className="mt-10 flex items-center justify-center gap-x-6">
            <div className="flex flex-col space-y-1 text-sm font-medium text-gray-900">
              <span aria-hidden="true">Contact support</span>
              <a href="mailto:hello@doitpay.co">
                <span className="text-brand-blue font-light" aria-hidden="true">
                  hello@doitpay.co
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
